import { render } from "./Field.vue?vue&type=template&id=2db14b36"
import script from "./Field.vue?vue&type=script&lang=ts"
export * from "./Field.vue?vue&type=script&lang=ts"
script.render = render

export default script